import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron-down",
  "use": "chevron-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chevron-down\"><path fill=\"currentColor\" d=\"M2.53 5.11L12 14.58l9.47-9.47L24 7.64 13.26 18.37a1.77 1.77 0 0 1-2.52 0L0 7.64z\" data-name=\"Icons-/-Large-/-Primary-/-Up\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol